import { render, staticRenderFns } from "./GenericItem.vue?vue&type=template&id=1845df6f&"
import script from "./GenericItem.vue?vue&type=script&lang=js&"
export * from "./GenericItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1845df6f')) {
      api.createRecord('1845df6f', component.options)
    } else {
      api.reload('1845df6f', component.options)
    }
    module.hot.accept("./GenericItem.vue?vue&type=template&id=1845df6f&", function () {
      api.rerender('1845df6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/meeting-agendas/modal-items/GenericItem.vue"
export default component.exports